// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__HqieU","dialog__wrapper":"Dialog_dialog__wrapper__DFqy1","large":"Dialog_large__ctGbk","medium":"Dialog_medium__jk3Np","tiny":"Dialog_tiny__Qji4I"};